import { PublicClientApplication } from "@azure/msal-browser";

let msalInstance = null;

if (typeof window !== "undefined" && window.crypto && window.crypto.subtle) {
  const isLocalhost = window.location.hostname === "localhost";

  const msalConfig = {
    auth: {
      clientId: "ea9f0883-5b6a-4f79-a5b1-dc563969943a",
      authority: "https://login.microsoftonline.com/common",
      redirectUri: isLocalhost
        ? "http://localhost:3000"
        : "https://chatbot.vps.matchperfect.nl",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
  };

  msalInstance = new PublicClientApplication(msalConfig);
} else {
  console.warn("MSAL is niet geïnitialiseerd – window.crypto.subtle niet beschikbaar");
}

export { msalInstance };